/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./batchReviewMaterial.vue?vue&type=template&id=1e13f298&scoped=true&"
import script from "./batchReviewMaterial.vue?vue&type=script&lang=js&"
export * from "./batchReviewMaterial.vue?vue&type=script&lang=js&"
import style0 from "./batchReviewMaterial.vue?vue&type=style&index=0&id=1e13f298&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e13f298",
  null
  
)

export default component.exports